export const config = {
  data() {
    return {
      columns: []
    };
  },
  mounted() {
    this.getColumns();
  },
  methods: {
    getColumns() {
      const columns = [];
      if(!this.hideAction && (this.tabId == 1 || this.tabId == 2) && this.$units.pointAction('offline_81_8_btn6')) {
        columns.push({
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center'
        });
      }
      columns.push({
        title: '业务员姓名',
        key: 'userName',
        minWidth: 200,
        fixed: 'left',
        align: 'center',
        slot: 'userName'
      });
      if (this.tabId == 1 || this.tabId == 3) {
        columns.push({
          title: '状态',
          minWidth: 120,
          align: 'center',
          fixed: 'left',
          slot: 'status'
        });
      }

      if (this.tabId == 2) {
        columns.push(
          {
            title: '保单号',
            key: 'policyNo',
            minWidth: 140,
            align: 'center'
          },
          {
            title: '批单号',
            key: 'billNo',
            minWidth: 140,
            align: 'center',
            render(h, params) {
              return <span>{params.row.billNo || '-'}</span>;
            }
          },
          {
            title: '保险公司',
            key: 'companyName',
            minWidth: 140,
            align: 'center'
          },
          {
            title: '保险产品',
            key: 'productName',
            minWidth: 140,
            align: 'center'
          },
          {
            title: '险种名称',
            key: 'insuranceName',
            minWidth: 140,
            align: 'center'
          },
          {
            title: '最新状态',
            slot: 'policyStatus',
            minWidth: 140,
            align: 'center'
          },
          {
            title: '保费',
            key: 'fee',
            minWidth: 140,
            align: 'center'
          },
          {
            title: '费率',
            key: 'commission',
            minWidth: 140,
            align: 'center',
            render(h, params) {
              const text = params.row.commission ? (params.row.commission * 1).mul(100) + '%' : '0%';
              return <span>{text}</span>;
            }
          },
          {
            title: '费用',
            key: 'commissionPrice',
            minWidth: 140,
            align: 'center',
            render(h, params) {
              const text = params.row.commissionPrice ? params.row.commissionPrice + '元' : '0元';
              return <span>{text}</span>;
            }
          }
        );
      } else if (this.tabId == 1 || this.tabId == 3) {
        if (this.tabId == 3) {
          columns.push(
            {
              title: '提现类型',
              key: 'withdrawType',
              minWidth: 140,
              align: 'center',
              render(h, params) {
                const withdrawType = params.row.withdrawType;
                return <span>{withdrawType == '2' ? '支付宝' : '银行卡'}</span>;
              }
            },
            {
              title: '金额',
              key: 'netIncome',
              minWidth: 140,
              align: 'center'
            }
          );
        }
        columns.push(
          {
            title: '结算主体',
            key: 'settlementEntity',
            minWidth: 160,
            align: 'center'
          },
          {
            title: '所属机构',
            key: 'orgName',
            minWidth: 160,
            align: 'center'
          },
          {
            title: '所属团队',
            key: 'groupName',
            minWidth: 160,
            align: 'center'
          },
          {
            title: '证件类型',
            key: 'cardType',
            minWidth: 130,
            align: 'center'
          },
          {
            title: '证件号',
            slot: 'idNo',
            minWidth: 180,
            align: 'center'
          },
          {
            title: '银行预留手机号',
            slot: 'mobile',
            minWidth: 160,
            align: 'center'
          },
          {
            title: '开户行',
            key: 'bank',
            minWidth: 160,
            align: 'center'
          },
          {
            title: '银行账号',
            slot: 'cardNo',
            minWidth: 160,
            align: 'center'
          },
          {
            title: '支付宝账号',
            slot: 'alipayAccount',
            minWidth: 160,
            align: 'center'
          }
        );
      }
      if (!this.hideAction) {
        columns.push({
          title: '操作',
          slot: 'action',
          className: 'action-columns',
          width: this.tabId == 2 ? 100 : 200,
          fixed: 'right',
          align: 'center'
        });
      }
      this.columns = columns;
    }
  }
};
